
  import { mapState, mapGetters } from 'vuex'
  import baseLogic from '~/mixins/base-logic'
  import cms from '~/mixins/common/cms'
  import playGames from '~/mixins/common/play-games'
  import vipSettings from '~/mixins/pages/mission-control/vipSettings'
  export default {
    name: 'Theme3NavBar',
    mixins: [baseLogic, cms, playGames, vipSettings],
    data() {
      return {
        drawer: false,
        displayExchangeRate: false,
        displayNotification: false,
        maxLogoImageWidth: 0,
        isInitializedHeaderLogoDone: false
      }
    },
    computed: {
      ...mapState({
        isLogin: state => state.settings.isLogin,
        player: state => state.player.player,
        operationSetting: state => state.settings.operationSetting,
        isApp: state => state.app.isApp,
        cms: state => state.cms.cms,
        isFooterComponentLoaded: state => state.cms.isFooterComponentLoaded,
        vipTiers: state => state.activities['vip-system'].vipTiers,
        missionBadge: state => state.activities['mission-reward'].missionBadge
      }),
      ...mapGetters({
        headerLogo: 'cms/headerLogo',
        footerPartnerIcon: 'cms/footerPartnerIcon',
        footerArticle1: 'cms/footerArticle1',
        footerArticle2: 'cms/footerArticle2',
        footerArticle3: 'cms/footerArticle3',
        footerArticle4: 'cms/footerArticle4',
        footerGamingInfo: 'cms/footerGamingInfo',
        footerTermAndCondition: 'cms/footerTermAndCondition',
        announcement: 'cms/announcement',
        certificateImage: 'cms/certificateImage'
      }),
      isPlayGamePage() {
        return this.$route.path === '/play-game'
      },
      isHomePage() {
        return this.$route.path === '/'
      },
      navItems() {
        // Navigation card items for the drawer
        const items = [
          {
            key: 'cashier',
            route: '/cashier',
            icon: '/theme-2/drawer/cashier.png',
            alt: 'cashier',
            title: 'cashier',
            show: true
          },
          {
            key: 'history',
            route: '/history/transaction',
            icon: '/theme-2/drawer/history.png',
            alt: 'history',
            title: 'history',
            show: true
          },
          {
            key: 'promotion',
            route: '/promotion',
            icon: '/theme-2/drawer/promotion.png',
            alt: 'promotion',
            title: 'promotion',
            show: true
          },
          {
            key: 'activities',
            route: '/activities',
            icon: '/theme-2/drawer/activities.png',
            alt: 'activities',
            title: 'activities',
            show: this.missionStatusInfo?.mission_status
          }
        ]
        return items.filter(i => i.show)
      },
      isPartnerIconsVisible() {
        return (
          this.footerPartnerIcon?.is_visible &&
          this.getVisibleItems(this.footerPartnerIcon?.items).length > 0
        )
      },
      isFollowUsVisible() {
        return (
          this.footerArticle4?.is_visible &&
          this.getVisibleItems(this.footerArticle4?.items).length > 0
        )
      },
      isGamingInfoVisible() {
        return this.footerGamingInfo?.is_visible
      }
    },
    mounted() {
      // this.initializeLogoWidth()
      if (this.$cookie.get('token')) {
        if (this.player.player_id) return
        this.$store.dispatch('player/profile')
        this.$store.dispatch('settings/toggleIsLogin', true)
        this.$store.dispatch('player/totalBalance')
      }
      if (this.$route.path !== '/' && this.isMobileOnly() && !this.isFooterComponentLoaded) {
        this.$store.dispatch('cms/footerCMS', { platform: 2 })
      }
      if (this.$route.path !== '/')
        this.$store.dispatch('cms/cmsComponentCode', {
          platform: 2,
          component_code: 'HeaderLogo'
        })
    },
    beforeDestroy() {
      this.doCancelAxiosRequest()
    },
    methods: {
      onDisplayExchangeRate() {
        this.drawer = false
        this.displayExchangeRate = true
      },
      goToDetail(item) {
        if (item?.items?.length > 0) {
          const title = item?.title[`${this.handleCookie('wl_locale')}-slug`]
          const slug =
            item?.items?.length > 0
              ? item?.items[0]?.title[`${this.handleCookie('wl_locale')}-slug`]
              : ''
          const subId = item?.items[0]?._id
          this.$router.push(
            `/articles/${encodeURIComponent(title || '-')}/${encodeURIComponent(
              slug || '-'
            )}?main_id=${item?._id}&sub_id=${subId}&component_code=${item.component_code}`
          )
        } else {
          this.$router.push('/articles')
        }
      },
      navigateTo(route) {
        this.$router.push(route)
      },
      getVisibleItems(items) {
        return Array.isArray(items) ? items.filter(i => i.is_visible !== false) : []
      },
      openNewBrowserTab(url) {
        if (url) window.open(url, '_blank')
      },
      initializeLogoWidth() {
        if (this.isInitializedHeaderLogoDone) return
        const _this = this
        setTimeout(() => {
          const headerEl = document.getElementById('mobile-header-el')
          const loginBtnEl = document.getElementById('login-btn-el')
          const burgerIconEl = document.getElementById('menu-bar-id')
          const headerElPadding = 24
          if (headerEl) {
            const maxAllowedImageWidth =
              headerEl.offsetWidth -
              (loginBtnEl.offsetWidth + burgerIconEl.offsetWidth + headerElPadding)

            this.maxLogoImageWidth = maxAllowedImageWidth
          }
        }, 500)

        setTimeout(() => {
          document.querySelectorAll('.header-logo-container img').forEach(img => {
            _this.isInitializedHeaderLogoDone = true
            if (img.naturalWidth > img.parentElement.clientWidth) {
              img.style.width = '90%'
              img.style.maxWidth = '200px'
              img.style.height = 'auto'
              img.style.maxHeight = '40px'
              img.style.opacity = 1
            } else {
              img.style.opacity = 1
            }
          })
          _this.initializeLogoWidth()
        }, 500)
      }
    }
  }
